import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {LocationType} from "../../../commons/types/location.type";
import {getFulfillmentLineItems} from "../../utils/fulfillment-line-items.util";

export class fulfillmentTableItemComponent implements IController {

  fulfillment: any;
  isCollapse: boolean;
  isSelected: string;
  fulfillmentSelectedSteps: any[];
  excludeMode: boolean;
  onOpen: Function;
  onDispatch: Function;
  onToggleSelect: Function;
  onCancelOrder: Function;
  onEditOrder: Function;
  onAddOrderNote: Function;
  onDuplicateOrder: Function;
  onPrintBillOfLading: Function;
  onDownloadBillOfLading: Function;
  onSetOrderOnHold: Function;
  onRestoreFulfillment: Function;

  public fulfillmentLinesStepProgress: any = {};
  public fulfillmentLinesSteps: any = {};
  public fulfillmentLinesItems: any = {};
  public filteredStepsCount: number = 0;
  public isChecked: boolean = false;
  public isPartiallyChecked: boolean = false;
  public locationTypes: typeof LocationType = LocationType;
  public fulfillmentLineItemsIds: string[] = [];
  public fulfillmentLineItemsTypes: string[] = [];
  public fulfillmentLineItemsBarcodes: string[] = [];
  public sitePackageItemsMap: any;
  public canCopyAccount: boolean = false;
  public canCopyProgramName: boolean = false;
  public canCopyPickupDepot: boolean;
  public canCopyDestinationDepot: boolean;
  public canCopyPickupAccount: boolean;
  public canCopyDestinationAccount: boolean;
  public canCopyPickupCustomer: boolean;
  public canCopyDestinationCustomer: boolean;
  public canCopyPickupCustomContact: boolean;
  public canCopyDestinationCustomContact: boolean;


  constructor(private splitService) {
  }

  $onInit() {
    this.sitePackageItemsMap = this.splitService.getSitePackageItemsMap();
    this._setFulfillmentLinesSteps();
    this._getStepProgress();
    this._setFulfillmentLinesPackages();
    this._filteredSteps();
    this._isFulfillmentChecked();
  }

  $onChanges(changes) {
    if (changes.fulfillmentSelectedSteps && !changes.fulfillmentSelectedSteps.isFirstChange() || changes.excludeMode && !changes.excludeMode.isFirstChange()) {
      this._isFulfillmentChecked();
    }
  }

  private _setFulfillmentLinesSteps() {
    this.fulfillmentLinesSteps = {};
    _.forEach(_.get(this.fulfillment, 'linesInfo', []), line => {
      this.fulfillmentLinesSteps[line.id] = [];
    });
    _.forEach(_.get(this.fulfillment, 'fulfillmentSteps', []), step => {
      if (step.fulfillmentLineId) {
        this.fulfillmentLinesSteps[step.fulfillmentLineId].push(step);
      }
    });
  }

  private _filteredSteps() {
    _.forEach(this.fulfillment.fulfillmentSteps, step => {
      if (step.matchFilter) {
        this.filteredStepsCount += 1;
      }
    })
  }

  private _getStepProgress() {
    _.forOwn(this.fulfillmentLinesSteps, (fulfillmentLineSteps, fulfillmentLineId) => {
      let completedCount = 0;
      _.forEach(fulfillmentLineSteps, step => {
        completedCount += step.status === 'Completed' ? 1 : 0;
      })
      this.fulfillmentLinesStepProgress[fulfillmentLineId] = {
        stepNumber: completedCount,
        numberOfSteps: fulfillmentLineSteps.length
      }
    });
  }

  private _setFulfillmentLinesPackages() {
    _.forEach(this.fulfillment.linesInfo, fulfillmentLine => {
      this.fulfillmentLinesItems[fulfillmentLine.id] = getFulfillmentLineItems(fulfillmentLine, _.get(this.fulfillment, 'items', []))
    })
    _.forOwn(this.fulfillmentLinesItems, (i, key) => {
      this.fulfillmentLineItemsIds[key] = _.map(i, 'id')
      this.fulfillmentLineItemsBarcodes[key] = _.chain(i)
        .filter(item => {
          return item.barcode
        })
        .map(item => {
          return item.barcode
        })
        .value();
      this.fulfillmentLineItemsTypes[key] = _.map(i, item => {
        return this.sitePackageItemsMap[item?.type]?.name;
      })
    })
  }

  private _isFulfillmentChecked() {
    const stepsMatchedFilterCount = _.filter(this.fulfillment.fulfillmentSteps, (s) => {
      return !!s.matchFilter;
    }).length

    const selectedStepsInFilterCount = _.filter(this.fulfillmentSelectedSteps, (id) => {
      return _.find(this.fulfillment.fulfillmentSteps, (step) => {
        return !!step.matchFilter && _.isEqual(step.id, id);
      })
    }).length
    const selectedStepsOutOfFilterCount = _.filter(this.fulfillmentSelectedSteps, (id) => {
      return _.find(this.fulfillment.fulfillmentSteps, (step) => {
        return !step.matchFilter && _.isEqual(step.id, id);
      })
    }).length

    this.isChecked = !this.excludeMode ? (selectedStepsInFilterCount + selectedStepsOutOfFilterCount === this.fulfillment.fulfillmentSteps.length) : ((stepsMatchedFilterCount - selectedStepsInFilterCount + selectedStepsOutOfFilterCount) > 0)

    this.isPartiallyChecked = !this.excludeMode ?
      ((selectedStepsInFilterCount + selectedStepsOutOfFilterCount > 0) && (selectedStepsInFilterCount + selectedStepsOutOfFilterCount !== this.fulfillment.fulfillmentSteps.length)) :
      (((stepsMatchedFilterCount - selectedStepsInFilterCount + selectedStepsOutOfFilterCount) > 0) && (stepsMatchedFilterCount - selectedStepsInFilterCount + selectedStepsOutOfFilterCount) < this.fulfillment.fulfillmentSteps.length);
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentTableItem', {
    require: {
      fulfillmentsTableCtrl: '^fulfillmentsTable'
    },
    bindings: {
      fulfillment: '<',
      isCollapse: '<',
      isSelected: '<',
      fulfillmentSelectedSteps: '<',
      excludeMode: '<',
      onToggleSelect: '&',
      onOpen: '&',
      onDispatch: '&',
      onCancelOrder: '&',
      onEditOrder: '&',
      onAddOrderNote: '&',
      onDuplicateOrder: '&',
      onPrintBillOfLading: '&',
      onDownloadBillOfLading: '&',
      onSetOrderOnHold: '&',
      onRestoreFulfillment: '&'
    },
    template: require('./fulfillment-table-item.html').default,
    controller: fulfillmentTableItemComponent
  });
